
<!-- 上报成绩查询 -->
<template>
    <div class="mainDiv">
        <div style="position: relative">
            <el-tabs v-model="reviewStatus" type="card">
                <el-tab-pane v-for="item in reviewStatusList" :key="item.value" :label="item.label" :name="item.name">
                </el-tab-pane>
            </el-tabs>
        </div>

        <div class="tab">
            <div class="control">
                <el-col :span="6">
                    <el-input v-model="phone" clearable placeholder="-请输入手机号-"></el-input>
                </el-col>
                 <el-col :span="6">
                    <el-input v-model="fullname" clearable placeholder="-请输入学生姓名-"></el-input>
                </el-col>
                <el-button type="primary" size="mini" @click="search">搜索</el-button>
            </div>
        </div>

        <el-table :data="tableData" style="width: 100%" size="small"
            :header-cell-style="{ 'background-color': '#e8eff9' }" @selection-change="handleSelectionChange"
            @cell-mouse-enter="cellMouseeEnter" @cell-mouse-leave="cellMouseLeave">
            <el-table-column type="selection" width="50" align="center" header-align="center">
            </el-table-column>
            <el-table-column label="序号" width="50" align="center" header-align="center">
                <template slot-scope="scope">{{
                        scope.$index + 1 + (pageObj.page - 1) * pageObj.pageSize
                }}</template>
            </el-table-column>
            <el-table-column prop="fullname" label="姓名" align="center" header-align="center">
            </el-table-column>
            <el-table-column sortable prop="phone" label="手机号(账号)" align="center" header-align="center">
            </el-table-column>
            <el-table-column sortable prop="batch" label="批次号/班级编码" align="center" header-align="center">
            </el-table-column>
            <el-table-column sortable prop="albumTitle" label="班级名称" align="center" header-align="center"></el-table-column>
            <el-table-column sortable prop="videoTitle" label="课程名称" align="center" header-align="center">
            </el-table-column>
            <el-table-column sortable prop="finalScore" label="课程成绩" align="center" header-align="center">
            </el-table-column>
            <el-table-column sortable prop="reportTime" label="上报时间" align="center" header-align="center">
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pageObj.page" :page-sizes="[10, 20, 30, 40]" :page-size="pageObj.pageSize"
            layout="total, sizes, prev, pager, next, jumper" background :total="total">
        </el-pagination>
    </div>
</template>

<script>

import * as api from '@/api/LookReport/index.js'

export default {
    components: {


    },
    data() {
        return {
            reviewStatusList: [{
                value: '1',
                label: '上报成绩查询',
                name: '1',
            }],
            // 检索参数
            phone:'',
            fullname:'',
            reviewStatus: '1',
            // 勾选的数组
            selectedList: [],
            tableData: [],
            pageObj: {
                page: 1,
                pageSize: 20,
            },
            total: 0,
        }
    },
    computed: {
        getUId() {
            return localStorage.getItem('uid')
        },
        url() {
            let url = window.location.protocol + '//' + window.location.host
            if (window.location.host == 'localhost:5001') {
                url = 'http://gz.hnjk.net'
            }
            return url
        },
    },

    created() {
      this.getList()
      //  监听键盘事件
    //   window.addEventListener('keyup', this.enterQuery)
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.enterQuery)
    },
    methods: {
        
        // 获取上报成绩查询
        async getList() {
            const { code, data } = (
                await api.getReportList({
                    uid: this.getUId,
                    phone:this.phone,
                    fullname:this.fullname,
                    ...this.pageObj,
                })
            ).data
            if (code === 100000) {
                this.tableData = data.list
                this.total = data.total
            }
        },
       
        enterQuery(e) {
            if (e.key === 'Enter') {
                this.search()
            }
        },
        //搜索
        search() {
            this.pageObj.page = 1
            this.getList()
        },

        // 处理选中事件
        handleSelectionChange(arr) {
            this.selectedList = arr
        },

        // 改变页面接收数据大小
        handleSizeChange(val) {
            this.pageObj.pageSize = val
            this.getList()
        },
        // 改变当前页面
        handleCurrentChange(val) {
            this.pageObj.page = val
            this.getList()
        },

        cellMouseeEnter(row, column, cell, event) {
            const colName = ['classCode']
            if (colName.includes(column.property)) {
                cell.style.color = 'rgb(64,158,255)'
                cell.style.cursor = 'pointer'
            }
        },
        cellMouseLeave(row, column, cell, event) {
            const colName = ['classCode']
            if (colName.includes(column.property)) {
                cell.removeAttribute('style')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';

/deep/.el-collapse {
    padding-bottom: 20px;
}

.table_control {
    color: #409eff;

    .table_control_item {
        vertical-align: middle;
        cursor: pointer;
    }
}

/deep/ .el-table th>.cell {
    white-space: pre-wrap;
}
</style>
